// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuHome_wrapper__mdi3r","menu":"MenuHome_menu__Ur8at","icon":"MenuHome_icon__cEtpQ","on":"MenuHome_on__fH8Re"};